import { FeedNotFoundException, ProductNotFoundException, CategoryProductNotFoundException } from '@scalefast/core';
import CREDENTIALS_EXCEPTIONS from '../../../Shared/Infrastructure/Exception/CredentialsExceptionMap';
const PRODUCT_EXCEPTIONS = [{
  errorCode: '-29',
  exception: new ProductNotFoundException()
}, {
  errorCode: '-35',
  exception: new FeedNotFoundException()
}, {
  errorCode: '-1403',
  exception: new CategoryProductNotFoundException()
}, ...CREDENTIALS_EXCEPTIONS];
export default PRODUCT_EXCEPTIONS;
